import React from 'react';

import CodeApp from './components/code-app';
import WithQuery from '../../../../common/components/with-query';

const Verify = props => {
  return (
    <WithQuery query={props.location.search}>
      <CodeApp />
    </WithQuery>
  );
}

export default Verify;
